import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-394b142a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "theme-color" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_nav = _resolveComponent("my-nav")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.menuList, (v) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: v.name
      }, [
        (v.children && v.children.length > 0 )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(), _createBlock(_component_el_submenu, {
                index: v.name,
                key: v.name
              }, {
                title: _withCtx(() => [
                  (v.meta.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "iconfont menuIcon",
                        innerHTML: v.meta.icon
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(v.meta.name), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_my_nav, {
                        menuList: v.children
                      }, null, 8, ["menuList"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["index"]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!v.meta.hide)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: v.name,
                    index: v.name,
                    onClick: ($event: any) => (_ctx.gotoRoute(v.name))
                  }, {
                    default: _withCtx(() => [
                      (v.meta.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "iconfont menuIcon",
                            innerHTML: v.meta.icon
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(v.meta.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["index", "onClick"]))
                : _createCommentVNode("", true)
            ]))
      ], 64))
    }), 128))
  ]))
}